import { useState } from "react";
import { useAuthContext } from "../../contexts/auth";
import { updateQueryString } from "../../util/url";
import { useRouter } from "next/router";

// @material-ui/core components
import { makeStyles } from "tss-react/mui";

// core components
import Image from "next/image.js";
import Link from "next/link";
import Button from "../CustomButtons/Button.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons"

// sections for this page
import ForumsProfileQuickView from "../ForumsProfileQuickView/ForumsProfileQuickView";
import ForumsModal from "../ForumsModal/ForumsModal";

import styles from "../../styles/jss/nextjs-material-kit/pages/forumsStyle.js";
import userPlaceholder from "../../public/img/no_profile.png";
import { buildSlug } from "../../util/url";

const useStyles = makeStyles()(styles);


export default function ForumsMeetApprenticesPanel(props) {
    const { classes, cx } = useStyles();
    const data = props.data;
    const { auth } = useAuthContext();
    const router = useRouter();
    const [quickViewOpen, setQuickViewOpen] = useState(false);
    const [quickViewData, setQuickViewData] = useState(null);

    const apprentices = props.apprentices;
    const employerName = props.employerName || null;
    const employerId = props.employerId || null;

    // TODO fetch apprentices that have posted most recently
    const mostRecentApprentices = [...apprentices]?.slice(0, 4);
    
    const [apprenticeSet, setApprenticeSet] = useState(1);
    const [apprenticesToShow, setApprenticesToShow] = useState([...mostRecentApprentices]?.slice(0, 2));

    const openQuickView = (apprentice) => {
        setQuickViewData(apprentice);
        setQuickViewOpen(true);
    }

    const closeQuickView = () => {
        setQuickViewOpen(false);
    }

    const handleApprenticeClick = async (e, apprentice) => {
        if (auth.user == null) {
            await router.push(updateQueryString(updateQueryString(router.asPath, "login", null), "redirectUrl", router.asPath));
        }
        else {
            openQuickView(apprentice);
        }
    }

    const scrollApprentices = () => {
        if (apprenticeSet === 1) {
            setApprenticeSet(2);
            setApprenticesToShow([...mostRecentApprentices?.slice(2, 4)]);
        } 
        else if (apprenticeSet === 2) {
            setApprenticeSet(1);
            setApprenticesToShow([...mostRecentApprentices?.slice(0, 2)]);
        }
    }

    const expandApprentices = () => {
        if (apprenticesToShow?.length === 2) {
            setApprenticesToShow([...mostRecentApprentices]);
        }
        else if (apprenticesToShow?.length > 2) {
            setApprenticesToShow([...mostRecentApprentices]?.slice(0, 2));
        }
    }

    return (
        <>
        {quickViewOpen &&
                <ForumsModal open={quickViewOpen} onClose={closeQuickView} closeButton={true} width={classes.width30}>
                    <ForumsProfileQuickView data={quickViewData} />
                </ForumsModal>
            }
            <h1 className={classes.forumSidePanelTitle}>{data?.category?.name} Mentors Answering Your Questions</h1>
            <div className={classes.scrollableApprenticePanel}>
            {apprenticeSet === 2 && mostRecentApprentices?.length > 2 &&
                <Button className={cx(classes.transparentButton + " " + classes.apprenticePanelScrollButton)} onClick={scrollApprentices} disabled={apprenticeSet === 1}>
                    <FontAwesomeIcon icon={faChevronLeft}/>
                </Button>
            }   
            <div className={classes.apprentices}>
                {apprenticesToShow?.map((apprentice, index) => {
                    return (
                        <Button onClick={(e) => handleApprenticeClick(e, apprentice)} className={classes.forumSidePanelApprentice} key={index}>
                            <Image src={apprentice.image ? apprentice.image : userPlaceholder || userPlaceholder} className={classes.forumSidePanelApprenticeImg} alt={"apprentice-profile-image"} width={50} height={50} />
                            <div className={classes.forumSidePanelApprenticeInfo}>
                                <p className={classes.forumSidePanelApprenticeName}>{apprentice.firstName}</p>
                                <p className={classes.forumSidePanelApprenticeTitle}>{apprentice.position}</p>
                            </div>
                        </Button>
                    )
                })}
            </div>
            {apprenticeSet === 1 && mostRecentApprentices?.length > 2 &&
                <Button className={cx(classes.transparentButton + " " + classes.apprenticePanelScrollButton)} onClick={scrollApprentices}>
                    <FontAwesomeIcon icon={faChevronRight}/>
                </Button>
            }
            {mostRecentApprentices?.length > 2 &&
                <Button className={cx(classes.transparentButton + " " + classes.apprenticePanelExpandButton)} onClick={expandApprentices}>{apprenticesToShow.length === 2 ? "View More" : "View Less"}</Button>
            }
            {employerId && apprentices?.length > 2 &&
                <Link href={`/community/mentors/${buildSlug(employerName)}/${employerId}`}>View All</Link>
            }
            </div>
            </>
    )
}

